<h3 mat-dialog-title>Ausstallen aus {{ gruppe?.bezeichnung }}</h3>

<div mat-dialog-content style="overflow-y: hidden">
    <div *ngIf="!isMobile">
        <div class="one-row">
            <!--    Die Anzahl der Tiere (Anzahl verfügbare)-->
            <mat-form-field style="width: 49%; margin: 0 0 -1em">
                <mat-label
                    >Anzahl Tiere <small>(verfügbar: {{ gruppe?.anzahl_tiere_aktuell }})</small></mat-label
                >
                <input matInput type="number" [formControl]="anzahlTiereCtrl" />
            </mat-form-field>
            <span class="spacer"></span>
            <!--    Das Ausstalldatum-->
            <mat-form-field style="width: 49%; margin: 0 0 -1em">
                <mat-label>Ausstalldatum</mat-label>
                <input matInput [matDatepicker]="picker" [formControl]="ausstalldatumCtrl" readonly />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="one-row">
            <!--    Das Ausstallgewicht-->
            <mat-form-field style="width: 32%; margin: 0 0 -1em">
                <mat-label>Ausstallgewicht <small>pro Tier (kg)</small></mat-label>
                <input matInput type="number" [formControl]="ausstallgewichtProTierCtrl" />
            </mat-form-field>
            <span class="spacer"></span>
            <!--    Die eingesetzte Futtermenge-->
            <mat-form-field style="width: 32%; margin: 0 0 -1em">
                <mat-label>Futtermenge <small>pro Tier (kg)</small></mat-label>
                <input matInput type="number" [formControl]="futtermengeProTierCtrl" />
            </mat-form-field>
            <span class="spacer"></span>
            <mat-form-field style="width: 32%; margin: 0 0 -1em">
                <mat-label>Futtermenge <small>Gesamt (kg)</small></mat-label>
                <input matInput type="number" [formControl]="futtermengeGesamtCtrl" />
            </mat-form-field>
        </div>
    </div>
    <div *ngIf="isMobile">
        <!--    Die Anzahl der Tiere (Anzahl verfügbare)-->
        <mat-form-field style="width: 100%; margin: 0 0 -1.25em">
            <mat-label
                >Anzahl Tiere <small>(verfügbar: {{ gruppe?.anzahl_tiere_aktuell }})</small></mat-label
            >
            <input matInput type="number" [formControl]="anzahlTiereCtrl" />
        </mat-form-field>
        <!--    Das Ausstalldatum-->
        <mat-form-field style="width: 100%; margin: 0 0 -1.25em">
            <mat-label>Ausstalldatum</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="ausstalldatumCtrl" readonly />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <!--    Das Ausstallgewicht-->
        <mat-form-field style="width: 100%; margin: 0 0 -1.25em">
            <mat-label>Ausstallgewicht <small>pro Tier (kg)</small></mat-label>
            <input matInput type="number" [formControl]="ausstallgewichtProTierCtrl" />
        </mat-form-field>
        <!--    Die eingesetzte Futtermenge-->
        <mat-form-field style="width: 100%; margin: 0 0 -1.25em">
            <mat-label>Futtermenge <small>pro Tier (kg)</small></mat-label>
            <input matInput type="number" [formControl]="futtermengeProTierCtrl" />
        </mat-form-field>
        <mat-form-field style="width: 100%; margin: 0 0 -1.25em">
            <mat-label>Futtermenge <small>Gesamt (kg)</small></mat-label>
            <input matInput type="number" [formControl]="futtermengeGesamtCtrl" />
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Schließen</button>
    <button mat-flat-button color="accent" (click)="save()" [disabled]="isDisabled()">Ausstallen</button>
</div>
